export default "__VITE_ASSET__DviRO9kk__"